import React, { Component, Fragment } from "react";
import { CardContent, Card, Container } from "@material-ui/core";


import { connect } from "react-redux";

class KnowledgeBase extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: true,
      userData: {},
      statusLogin: false,
      cards: [],
      responseForgot: "",
      responseLogin: "",
      openAlert: true,
      notificationsList: [],
      notificationsLoaded: true
    };
    this.headersSetCookie = window.localStorage.getItem("headersSetCookie");
  }

  render() {
    return (
      <Fragment>
        <Container
          maxWidth="xl"
          style={{
            height: 'calc(100vh - 70px)',
            display: 'flex',
            flexDirection: 'column',
            paddingLeft: 8
          }}
        >
          <Card
            className="tableList tableList_paper card-box cardTableContainer"
            component="section"
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden'
            }}
          >
            <CardContent className="Detail_Action_ViewContainer_KnowledgeBase" style={{ flex: 1 }}>
              <iframe
                src="https://customer-service.travelcurious.net/portal/"
                width="100%"
                height="100%"
                frameBorder="0"
                title="Knowledge Base"
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
              />
            </CardContent>
          </Card>
        </Container>
      </Fragment>
    );
  }
}

const mapStateToProps = (reducers) => {
  return reducers.guidePortalReducer;
};

export default connect(mapStateToProps)(KnowledgeBase);